import React, { useEffect, useState } from 'react'
import { Table, Button } from 'react-bootstrap'
import InfiniteScroll from 'react-infinite-scroll-component';

import Loading from '../../components/Loading'
import Charge from '../../lib/Charge'
import { fetchCharges } from '../../lib/Charges'
import Helpers from '../../lib/Helpers';

const Charges = () => {
  const [state, setState] = useState({
    hasMore: false,
    page: 0,
    loading: true,
    charges: [],
    count: null,
  })

  const onFetchCharges = async () => {
    const { page } = state
    const newPage = page + 1
    const { charges: chargeList, pagy } = await fetchCharges(newPage);

    setState({
      count: pagy.count,
      page: newPage,
      loading: false,
      hasMore: pagy.page < pagy.pages,
      charges: [...state.charges, ...(chargeList || []).map((r) => new Charge(r))]
    })
  }

  const onCreatePayout = (charge) => async () => {
    if (!window.confirm("This will initiate a manual payout on stripe. The money frow the talent's connected account will be transferent to talent's bank account. You will not be able to create a refund anymore! Confirm?")) return null

    const res = await charge.createPayout()
    if (res.isError) {
      alert(res.error || "Unknown error occurred")
    } else {
      const charges = state.charges.filter((c) => c != charge)
      setState({ ...state, charges })
      alert(res.message)
    }
  }

  useEffect(() => {
    onFetchCharges()
  }, [])

  if (state.loading) return <Loading />

  const columns = ['Charge ID', 'Job Name', 'Client', 'Talent', 'Amount', 'Actions']

  return (
    <InfiniteScroll
      dataLength={state.charges.length}
      next={onFetchCharges}
      hasMore={state.hasMore}
      style={{
        overflow: 'hidden'
      }}
      loader={<Loading />}
    >
      <Table striped bordered hover>
        <thead>
          <tr>{columns.map((c) => <th>{c}</th>)}</tr>
        </thead>
        <tbody>
          {state.charges.map((r) => (
            <tr>
              <td>{r.stripe_charge_id}</td>
              <td>{r.project_name}</td>

              <td>
                {r.client_swipecast_id ? (
                  <a
                    target="_blank"
                    href={`${Helpers.frontendURL}/${r.client_swipecast_id}`}
                  >{r.client_full_name}</a>
                ) : 'N/A'}
              </td>

              <td>
                {r.bookee_id ? (
                  <a
                    target="_blank"
                    href={`${Helpers.frontendURL}/${r.bookee_id}`}
                  >{r.bookee_full_name}</a>
                ) : 'N/A'}
              </td>

              <td>{r.amount_label}</td>
              <td>
                <Button onClick={onCreatePayout(r)} bsStyle="danger">Payout</Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </InfiniteScroll >
  )
}

export default Charges
